import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiEdit2, FiTrash2, FiCalendar, FiUsers, FiMapPin, FiInbox, FiAlertTriangle, FiCopy, FiInfo, FiX, FiCamera, FiDownload, FiChevronDown, FiChevronUp, FiFileText, FiArrowDown, FiSettings, FiMessageSquare, FiShare2 } from 'react-icons/fi';

// Firebase importok - BŐVÍTVE: doc, deleteDoc, updateDoc, runTransaction
import { db, auth, storage } from '../../firebase';
import { collection, query, where, onSnapshot, doc, deleteDoc, getDocs, writeBatch, runTransaction, updateDoc, getDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { saveCompetitionOffline, getAllCompetitionsOffline, getOfflineParticipantsCount, getCompetitionOffline, cacheCompetitions } from '../../utils/offlineDB';
import downloadHelpImg from '../../downloadhelp.png';

const ClubDashboard = () => {
  const navigate = useNavigate();
  const [competitions, setCompetitions] = useState([]);
  const [closedCompetitions, setClosedCompetitions] = useState([]);
  const [clubData, setClubData] = useState(null); // ÚJ: Klub adatok (kreditekhez)
  const [loading, setLoading] = useState(true);
  const [isUploadingLogo, setIsUploadingLogo] = useState(false); // ÚJ: Feltöltés állapot
  const fileInputRef = React.useRef(null); // ÚJ: File input ref
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('active');
  const [expandedMenu, setExpandedMenu] = useState('competitions');

  // --- ÚJ: EGYESÜLETI PROFIL SZERKESZTŐ ÁLLAPOTOK ---
  const [profileForm, setProfileForm] = useState({
    clubName: '',
    contactPerson: '',
    email: '',
    phone: '',
    country: '',
    location: '',
    address: ''
  });
  const [isSavingProfile, setIsSavingProfile] = useState(false);

  // Profil adatok betöltése a formba, ha megérkezik a clubData
  useEffect(() => {
    if (clubData) {
      setProfileForm({
        clubName: clubData.clubName || '',
        contactPerson: clubData.contactPerson || '',
        email: clubData.email || '',
        phone: clubData.phone || '',
        country: clubData.country || 'Magyarország',
        location: clubData.location || '',
        address: clubData.address || ''
      });
    }
  }, [clubData]);

  const handleSaveClubProfile = async () => {
    if (!user) return;
    setIsSavingProfile(true);
    try {
      const clubRef = doc(db, "Clubs", user.uid);
      await updateDoc(clubRef, {
        ...profileForm,
        updatedAt: new Date().toISOString()
      });
      alert("Egyesületi profil sikeresen frissítve! 🏹✅");
      setActiveTab('active'); // Visszatérés az aktív versenyekhez
    } catch (error) {
      console.error("Hiba a profil mentésekor:", error);
      alert("Nem sikerült a mentés.");
    } finally {
      setIsSavingProfile(false);
    }
  };

  // --- MODAL ÁLLAPOTOK ---
  const [showModal, setShowModal] = useState(false);
  const [showOpenRegistrationModal, setShowOpenRegistrationModal] = useState(false);
  const [showInstallInfoModal, setShowInstallInfoModal] = useState(false);
  const [showPublishConfirmModal, setShowPublishConfirmModal] = useState(false); // ÚJ: Publikálás megerősítő modal
  const [compToPublish, setCompToPublish] = useState(null); // ÚJ: Kiválasztott verseny a publikáláshoz
  const [isPublishing, setIsPublishing] = useState(false); // ÚJ: Publikálás folyamatban
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isStandalone, setIsStandalone] = useState(false); // ÚJ: Alkalmazás mód figyelése
  const [compToOpen, setCompToOpen] = useState(null);
  const [compToDelete, setCompToDelete] = useState(null);
  const [compToShare, setCompToShare] = useState(null); // ÚJ
  const [showShareModal, setShowShareModal] = useState(false); // ÚJ
  const [copySuccess, setCopySuccess] = useState(false); // ÚJ
  const [offlineStats, setOfflineStats] = useState({}); // ÚJ: { compId: count } a gombokhoz
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 1. Auth állapot figyelése ÉS Kezdeti offline betöltés
  useEffect(() => {
    const fetchInitialOfflineData = async () => {
      try {
        // 1. Helyi profil betöltése (gyorsabb mint az IndexedDB)
        const savedProfile = localStorage.getItem(`club_profile_${auth.currentUser?.uid}`);
        if (savedProfile) {
          setClubData(JSON.parse(savedProfile));
        }

        // 2. Versenyek betöltése IndexedDB-ből
        const offComps = await getAllCompetitionsOffline();
        if (offComps && offComps.length > 0) {
          const active = offComps.filter(c => c.status !== 'Ready to Upload' && c.status !== 'Lezárt');
          const closed = offComps.filter(c => c.status === 'Ready to Upload' || c.status === 'Lezárt');

          setCompetitions(active);
          setClosedCompetitions(closed);
          setLoading(false); // Ha van offline adat, már nem mutatunk üres töltést
        }
      } catch (e) {
        console.error("Hiba az offline adatok betöltésekor:", e);
      }
    };

    fetchInitialOfflineData();

    const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (!currentUser) setLoading(false);
    });
    return () => unsubscribeAuth();
  }, []);

  // 1b. PWA Telepítési esemény figyelése
  useEffect(() => {
    // ... meglévő kód ...
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // Detektáljuk, ha már standalone módban futunk
    const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    setIsStandalone(!!isStandaloneMode);

    // ÚJ: Offline adatok állapotának lekérése az induláskor
    const fetchOfflineStats = async () => {
      try {
        const offComps = await getAllCompetitionsOffline();
        const stats = {};
        for (const c of offComps) {
          const count = await getOfflineParticipantsCount(c.id);
          stats[c.id] = count;
        }
        setOfflineStats(stats);
      } catch (e) {
        console.error("Hiba az offline statisztika lekérésekor:", e);
      }
    };
    fetchOfflineStats();

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      alert("A böngésződ még nem készítette elő a telepítést. \n\nKérlek, keresd a (+) vagy 'Telepítés' ikont a címsorban, vagy várj pár másodpercet!");
      return;
    }
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
    setShowInstallInfoModal(false);
  };

  // 2. Adatok lekérése - INDEX-MENTESÍTVE az azonnali betöltéshez
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events, user:", user.uid);
    const q = query(
      collection(db, "events"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeSnapshot = onSnapshot(q, async (querySnapshot) => {
      // VÉDELEM: Ha üres a szerver válasza ÉS offline vagyunk, ne töröljük a listát
      if (querySnapshot.empty && !navigator.onLine) return;

      const serverComps = [];
      querySnapshot.forEach((doc) => {
        serverComps.push({ id: doc.id, ...doc.data() });
      });

      // --- AUTOMATA MENTÉS INDEXEDDB-BE ---
      if (serverComps.length > 0) {
        cacheCompetitions(serverComps);
      }

      // --- ÚJ: Hibrid Összefésülés (Helyi prioritás a lezáráshoz) ---
      try {
        const offComps = await getAllCompetitionsOffline();
        const locallyClosedIds = new Set(offComps.filter(c => c.status === 'Ready to Upload').map(c => c.id));

        // Csak azokat tartjuk meg az aktívak között, amik a laptopon nincsenek lezárva
        const filteredComps = serverComps.filter(c => !locallyClosedIds.has(c.id));

        // MANUÁLIS RENDEZÉS
        filteredComps.sort((a, b) => {
          const dateA = a.createdAt?.seconds || 0;
          const dateB = b.createdAt?.seconds || 0;
          return dateB - dateA;
        });

        setCompetitions(filteredComps);
      } catch (e) {
        console.error("Hiba az offline összefésüléskor (aktív):", e);
        setCompetitions(serverComps);
      }
      setLoading(false);
    }, async (error) => {
      console.error("Hiba az events lekérésekor:", error);
      // OFFLINE TARTALÉK: Ha hiba van (pl. nincs net), megpróbáljuk az offline tárolóból
      if (!navigator.onLine) {
        try {
          const offComps = await getAllCompetitionsOffline();
          setCompetitions(offComps);
        } catch (e) {
          console.error("Hiba az offline versenyek lekérésekor:", e);
        }
      }
      setLoading(false);
    });

    return () => unsubscribeSnapshot();
  }, [user]);

  // 3. Lezárt adatok lekérése az events_closed gyűjteményből
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events_closed, user:", user.uid);
    const q = query(
      collection(db, "events_closed"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeClosed = onSnapshot(q, async (querySnapshot) => {
      // VÉDELEM: Ha üres a szerver válasza ÉS offline vagyunk, ne töröljük a listát
      if (querySnapshot.empty && !navigator.onLine) return;

      const serverComps = [];
      querySnapshot.forEach((doc) => {
        serverComps.push({ id: doc.id, ...doc.data() });
      });

      // --- AUTOMATA MENTÉS INDEXEDDB-BE ---
      if (serverComps.length > 0) {
        cacheCompetitions(serverComps);
      }

      // --- ÚJ: Hibrid Összefésülés (Helyi "Ready to Upload" versenyek hozzáadása) ---
      try {
        const offComps = await getAllCompetitionsOffline();
        const readyToUpload = offComps.filter(c => c.status === 'Ready to Upload');

        // Összefésüljük a szerveres lezártakat a feltöltésre várókkal
        let allClosed = [...serverComps, ...readyToUpload];

        // Duplikáció szűrés (ha a szerveren is ott lenne véletlenül)
        const seen = new Set();
        allClosed = allClosed.filter(c => {
          if (seen.has(c.id)) return false;
          seen.add(c.id);
          return true;
        });

        allClosed.sort((a, b) => {
          const dateA = a.closedAt ? new Date(a.closedAt).getTime() : 0;
          const dateB = b.closedAt ? new Date(b.closedAt).getTime() : 0;
          return dateB - dateA;
        });

        setClosedCompetitions(allClosed);
      } catch (e) {
        console.error("Hiba az offline összefésüléskor (lezárt):", e);
        setClosedCompetitions(serverComps);
      }
    }, (error) => {
      console.error("Hiba az events_closed lekérésekor:", error);
    });

    return () => unsubscribeClosed();
  }, [user]);

  // 4. Klub adatok lekérése
  useEffect(() => {
    if (!user) return;

    const clubRef = doc(db, "Clubs", user.uid);
    const unsubscribeClub = onSnapshot(clubRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setClubData(data);
        localStorage.setItem(`club_profile_${user.uid}`, JSON.stringify(data));
      } else {
        setClubData({});
      }
    });

    return () => unsubscribeClub();
  }, [user]);

  // --- LOGÓ FELTÖLTÉS LOGIKA ---
  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !user) return;

    // Fájltípus ellenőrzés
    if (!file.type.startsWith('image/')) {
      alert("Kérlek, csak képfájlt válassz ki!");
      return;
    }

    setIsUploadingLogo(true);
    try {
      // 1. Feltöltés Firebase Storage-ba
      const logoRef = ref(storage, `club_logos/${user.uid}`);
      await uploadBytes(logoRef, file);

      // 2. Letöltési URL lekérése
      const downloadUrl = await getDownloadURL(logoRef);

      // 3. Adatbázis frissítése
      const clubRef = doc(db, "Clubs", user.uid);
      await updateDoc(clubRef, { logoUrl: downloadUrl });

      console.log("Logó sikeresen feltöltve:", downloadUrl);
    } catch (error) {
      console.error("Hiba a logó feltöltésekor:", error);
      alert("Nem sikerült a logó feltöltése!");
    } finally {
      setIsUploadingLogo(false);
    }
  };

  // --- TÖRLÉS LOGIKA ---
  const openDeleteModal = (comp) => {
    setCompToDelete(comp);
    setShowModal(true);
  };

  const handleFinalDelete = async () => {
    if (!compToDelete) return;

    const collectionName = activeTab === 'active' ? "events" : "events_closed";

    try {
      const batch = writeBatch(db);

      // 1. Nevezők (participants) lekérése és törlése a batch-ben
      const participantsRef = collection(db, collectionName, compToDelete.id, "participants");
      const participantsSnap = await getDocs(participantsRef);
      participantsSnap.forEach((participantDoc) => {
        batch.delete(participantDoc.ref);
      });

      // 2. A verseny fő dokumentumának hozzáadása a törlési listához
      batch.delete(doc(db, collectionName, compToDelete.id));

      // 3. Végrehajtjuk a teljes törlést egyszerre
      await batch.commit();
      
      // Frissítjük a helyi állapotot
      if (activeTab === 'active') {
        setCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      } else {
        setClosedCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      }
      
      setShowModal(false);
      setCompToDelete(null);
    } catch (error) {
      console.error("Hiba a törlés során:", error);
      alert("A törlés sikertelen!");
    }
  };

  const handleOpenRegistration = async () => {
    if (!compToOpen) return;
    try {
      const docRef = doc(db, "events", compToOpen.id);
      await updateDoc(docRef, { creationType: 'full_event' });
      setShowOpenRegistrationModal(false);
      setCompToOpen(null);
    } catch (error) {
      console.error("Hiba a nevezés megnyitásakor:", error);
      alert("Nem sikerült megnyitni a nevezést!");
    }
  };

  const downloadCompetitionOffline = async (comp) => {
    try {
      // 1. Lekérjük az összes nevezőt ehhez a versenyhez
      const participantsRef = collection(db, "events", comp.id, "participants");
      const participantsSnap = await getDocs(participantsRef);
      const participantsData = participantsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // 2. Mentés IndexedDB-be
      await saveCompetitionOffline(comp, participantsData);

      // --- ÚJ: AUTOMATIKUS SZÁMLÁLÓ JAVÍTÁS (Öntisztító funkció) ---
      const actualCount = participantsData.length;
      if (Number(comp.participantsCount) !== actualCount) {
        const eventRef = doc(db, "events", comp.id);
        await updateDoc(eventRef, { participantsCount: actualCount });
      }

      // 3. Frissítjük a helyi állapotot, hogy a gomb színe azonnal változzon
      setOfflineStats(prev => ({
        ...prev,
        [comp.id]: actualCount
      }));

      alert(`Sikeresen letöltve: ${comp.competitionName}\nMostantól használhatod offline módban is! 🏹✅`);
    } catch (error) {
      console.error("Hiba a letöltéskor:", error);
      alert("Hiba történt az adatok letöltése közben.");
    }
  };

  const handleFinalPublish = async () => {
    if (!compToPublish) return;
    setIsPublishing(true);
    try {
      // 1. ADATOLVASÁS: A laptopon tárolt legfrissebb adatokat használjuk!
      const offlineData = await getCompetitionOffline(compToPublish.id);
      const finalCompetition = offlineData.competition || compToPublish;
      const finalParticipants = offlineData.participants || [];

      if (finalParticipants.length === 0) {
        // Ha nincs helyi adat, megpróbáljuk a szerverről (hátha csak online lezárás volt)
        const participantsRef = collection(db, "events", compToPublish.id, "participants");
        const participantsSnap = await getDocs(participantsRef);
        participantsSnap.docs.forEach(doc => finalParticipants.push({ id: doc.id, ...doc.data() }));
      }

      const batch = writeBatch(db);

      // 2. FELTÖLTÉS ÉS LEZÁRÁS EGYBEN
      const closedEventRef = doc(db, "events_closed", compToPublish.id);
      batch.set(closedEventRef, {
        ...finalCompetition,
        status: 'Lezárt',
        published: true,
        closedAt: new Date().toISOString(),
        finalResultCount: finalParticipants.length
      });

      // 3. Résztvevők másolása (A laptopon lévő pontokkal!)
      finalParticipants.forEach(p => {
        const pRef = doc(db, "events_closed", compToPublish.id, "participants", p.id);
        // Biztosítjuk, hogy a pontok benne legyenek
        batch.set(pRef, p);

        // Eredeti törlése a szerverről
        const oldPRef = doc(db, "events", compToPublish.id, "participants", p.id);
        batch.delete(oldPRef);
      });

      // 4. Eredeti verseny törlése a szerverről
      batch.delete(doc(db, "events", compToPublish.id));

      await batch.commit();

      // SIKER UTÁN: Töröljük az offline tárolóból is, már nincs rá szükség
      // (Opcionális, de tisztább tőle a gép)

      setShowPublishConfirmModal(false);
      setCompToPublish(null);
      alert("Eredmények sikeresen feltöltve a laptopról és publikálva! 🏹🚀");
    } catch (error) {
      console.error("Hiba a publikáláskor:", error);
      alert("Hiba történt a feltöltés során. Ellenőrizd az internetkapcsolatot!");
    } finally {
      setIsPublishing(false);
    }
  };

  const handleCopyCompetition = (comp) => {
    // Adatok másolása és tisztítása
    const {
      id,
      participantsCount,
      createdAt,
      closedAt,
      status,
      registrationClosed,
      competitionDate,
      startDate,
      endDate,
      registrationDeadline,
      registrationChangeDeadline,
      ...rest
    } = comp;

    const copiedData = {
      ...rest,
      competitionName: `${comp.competitionName || comp.title} (MÁSOLAT)`,
      // Dátumokat ürítjük, hogy a szervezőnek meg kelljen adnia az újat
      competitionDate: '',
      startDate: '',
      endDate: '',
      registrationDeadline: '',
      registrationChangeDeadline: '',
      creationType: 'full_event',
      status: 'Aktív'
    };

    navigate('/verseny-letrehozas', { state: { copiedCompetition: copiedData } });
  };

  const handleCopyLink = () => {
    if (!compToShare) return;
    const url = `https://archerynexus.com/verseny/${compToShare.id}`;
    navigator.clipboard.writeText(url);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  // Statisztika számítása
  const totalParticipants = competitions.reduce((sum, comp) => sum + (Number(comp.participantsCount) || 0), 0);

  if (loading && !user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p style={{ fontSize: '1.2rem', color: '#b30000', fontWeight: 'bold' }}>Betöltés...</p>
      </div>
    );
  }

  // Versenyek szétválogatása
  const activeCompetitions = competitions.filter(c => c.status !== 'Ready to Upload' && c.status !== 'Lezárt');
  const readyToUploadComps = competitions.filter(c => c.status === 'Ready to Upload');
  const pastCompetitions = [...readyToUploadComps, ...closedCompetitions];
  
  // Éppen megjelenítendő lista
  const displayCompetitions = activeTab === 'active' ? activeCompetitions : pastCompetitions;

  // --- MOBIL SOROMPÓ NÉZET ---
  if (isMobile) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        height: 'calc(100vh - 64px)', padding: '20px', textAlign: 'center', backgroundColor: '#f4f6f8'
      }}>
        <div style={{
          backgroundColor: '#fff', padding: '40px 30px', borderRadius: '20px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)', maxWidth: '400px'
        }}>
          <div style={{
            width: '80px', height: '80px', backgroundColor: '#fff5f5', color: '#b30000',
            borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 20px auto'
          }}>
            <FiAlertTriangle size={40} />
          </div>
          <h2 style={{ color: '#333', marginBottom: '15px' }}>Egyesületi funkciók</h2>
          <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '25px' }}>
            Sajnáljuk, de az <strong>Irányítópult</strong> és a <strong>Versenyiroda</strong> jelenleg csak számítógépről érhető el.
          </p>
          <div style={{
            padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '12px',
            fontSize: '0.9rem', color: '#555', border: '1px solid #eee'
          }}>
            Kérjük, a versenyek kezeléséhez és az irodai munkához jelentkezz be egy <strong>asztali böngészőből!</strong> 💻
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              marginTop: '30px', width: '100%', padding: '12px',
              backgroundColor: '#b30000', color: '#fff', border: 'none',
              borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer'
            }}
          >
            Vissza a főoldalra
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f4f6f8', fontFamily: 'Arial, sans-serif' }}>
      
      {/* --- OLDALSÓ MENÜ (SIDEBAR) --- */}
      <div style={{
        width: '300px',
        backgroundColor: '#fff',
        borderRight: '1px solid #eee',
        padding: '30px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        position: 'sticky',
        top: 0,
        height: '100vh',
        boxSizing: 'border-box',
        zIndex: 100
      }}>
        {/* SIDEBAR PROFIL FEJLÉC */}
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
          <div style={{ position: 'relative' }}>
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              backgroundColor: '#eee',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              border: '3px solid #fff',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}>
              {clubData?.logoUrl ? (
                <img src={clubData.logoUrl} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <FiUsers size={50} color="#ccc" />
              )}

              {isUploadingLogo && (
                <div style={{
                  position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  <div className="upload-spinner" />
                </div>
              )}
            </div>

            <button
              onClick={() => fileInputRef.current?.click()}
              style={{
                position: 'absolute',
                bottom: '0',
                right: '0',
                backgroundColor: '#b30000',
                color: '#fff',
                border: '2px solid #fff',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
              }}
              title="Logó feltöltése"
            >
              <FiCamera size={18} />
            </button>

            <input
              type="file"
              ref={fileInputRef}
              onChange={handleLogoUpload}
              style={{ display: 'none' }}
              accept="image/*"
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
            <h3 style={{ color: '#333', margin: '0', fontSize: '1.2rem', fontWeight: '900' }}>
              {clubData?.clubName || clubData?.fullName || "Egyesület"}
            </h3>
            <button
              onClick={() => setActiveTab('club-profile')}
              style={{
                backgroundColor: '#b30000',
                color: 'white',
                border: 'none',
                padding: '6px 15px',
                borderRadius: '20px',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 2px 5px rgba(179,0,0,0.2)',
                transition: '0.2s',
                opacity: activeTab === 'club-profile' ? 0.7 : 1
              }}
            >
              Egyesületi Profil
            </button>
          </div>
        </div>

        <div style={{ height: '1px', backgroundColor: '#f0f0f0', width: '100%' }} />

        {/* TELEPÍTÉS GOMB (Mindig látszik böngészőben) */}
        {!isStandalone && (
          <button
            onClick={() => setShowInstallInfoModal(true)}
            style={{
              width: '100%',
              backgroundColor: '#b30000',
              color: 'white',
              border: 'none',
              padding: '12px',
              borderRadius: '10px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              cursor: 'pointer',
              boxShadow: '0 4px 8px rgba(179,0,0,0.2)',
              marginBottom: '15px'
            }}
          >
            <FiDownload size={20} />
            ArcheryNexus letöltése
          </button>
        )}

        {/* --- MENÜPONTOK --- */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>

          {/* 1. VERSENYEIM */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              onClick={() => setExpandedMenu(expandedMenu === 'competitions' ? null : 'competitions')}
              style={{ ...sidebarItemStyle, backgroundColor: expandedMenu === 'competitions' ? '#fff5f5' : 'transparent' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <FiCalendar size={18} color="#b30000" />
                <span style={{ fontWeight: 'bold', color: '#333' }}>Versenyeim</span>
              </div>
              {expandedMenu === 'competitions' ? <FiChevronUp color="#888" /> : <FiChevronDown color="#888" />}
            </div>

            {expandedMenu === 'competitions' && (
              <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '42px', gap: '5px', marginTop: '5px' }}>
                <div
                  onClick={() => setActiveTab('active')}
                  style={{ ...sidebarSubItemStyle, color: activeTab === 'active' ? '#b30000' : '#666', fontWeight: activeTab === 'active' ? 'bold' : 'normal' }}
                >
                  Aktív versenyek
                </div>
                <div
                  onClick={() => setActiveTab('past')}
                  style={{ ...sidebarSubItemStyle, color: activeTab === 'past' ? '#b30000' : '#666', fontWeight: activeTab === 'past' ? 'bold' : 'normal' }}
                >
                  Lezárt versenyek
                </div>
              </div>
            )}
          </div>

          {/* 2. DOKUMENTUMOK */}
          <div style={{ ...sidebarItemStyle, opacity: 0.6, cursor: 'default' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiFileText size={18} color="#b30000" />
              <span style={{ fontWeight: 'bold', color: '#333' }}>Dokumentumok</span>
            </div>
          </div>

          {/* 3. BEÁLLÍTÁSOK */}
          <div style={{ ...sidebarItemStyle, opacity: 0.6, cursor: 'default' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiSettings size={18} color="#b30000" />
              <span style={{ fontWeight: 'bold', color: '#333' }}>Beállítások</span>
            </div>
          </div>

          {/* 4. HIBAJELENTÉS / VISSZAJELZÉS */}
          <div
            onClick={() => navigate('/visszajelzes')}
            style={sidebarItemStyle}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiMessageSquare size={18} color="#b30000" />
              <span style={{ fontWeight: 'bold', color: '#333', lineHeight: '1.2' }}>
                Hibajelentés /<br/>Visszajelzés
              </span>
            </div>
          </div>

        </div>
      </div>

      {/* --- FŐ TARTALOM (JOBB OLDAL) --- */}
      <div style={{ flex: 1, padding: '40px', overflowY: 'auto' }}>

        {/* --- EGYESÜLETI PROFIL SZERKESZTŐ NÉZET --- */}
        {activeTab === 'club-profile' && (
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
              <button
                onClick={() => setActiveTab('active')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#666', display: 'flex', alignItems: 'center' }}
              >
                <FiArrowDown style={{ transform: 'rotate(90deg)' }} size={24} />
              </button>
              <h2 style={{ color: '#b30000', margin: 0 }}>Egyesületi Profil Szerkesztése</h2>
            </div>

            <div style={{ ...compCardStyle, padding: '30px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>

                {/* KLUB NEVE */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={labelStyle}>Egyesület Hivatalos Neve</label>
                  <input
                    type="text"
                    value={profileForm.clubName}
                    onChange={(e) => setProfileForm({...profileForm, clubName: e.target.value})}
                    style={inputStyle}
                    placeholder="Egyesület neve"
                  />
                </div>

                {/* KAPCSOLATTARTÓ */}
                <div>
                  <label style={labelStyle}>Kapcsolattartó Neve</label>
                  <input
                    type="text"
                    value={profileForm.contactPerson}
                    onChange={(e) => setProfileForm({...profileForm, contactPerson: e.target.value})}
                    style={inputStyle}
                    placeholder="Példa János"
                  />
                </div>

                {/* EMAIL */}
                <div>
                  <label style={labelStyle}>Email Cím</label>
                  <input
                    type="email"
                    value={profileForm.email}
                    onChange={(e) => setProfileForm({...profileForm, email: e.target.value})}
                    style={inputStyle}
                    placeholder="iroda@egyesulet.hu"
                  />
                </div>

                {/* TELEFONSZÁM */}
                <div>
                  <label style={labelStyle}>Telefonszám</label>
                  <input
                    type="text"
                    value={profileForm.phone}
                    onChange={(e) => setProfileForm({...profileForm, phone: e.target.value})}
                    style={inputStyle}
                    placeholder="+36 30 123 4567"
                  />
                </div>

                {/* SZÉKHELY - ORSZÁG */}
                <div>
                  <label style={labelStyle}>Ország</label>
                  <input
                    type="text"
                    value={profileForm.country}
                    onChange={(e) => setProfileForm({...profileForm, country: e.target.value})}
                    style={inputStyle}
                  />
                </div>

                {/* SZÉKHELY - VÁROS */}
                <div>
                  <label style={labelStyle}>Város (Helyszín)</label>
                  <input
                    type="text"
                    value={profileForm.location}
                    onChange={(e) => setProfileForm({...profileForm, location: e.target.value})}
                    style={inputStyle}
                  />
                </div>

                {/* PONTOS CÍM */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={labelStyle}>Pontos Cím (Utca, házszám)</label>
                  <input
                    type="text"
                    value={profileForm.address}
                    onChange={(e) => setProfileForm({...profileForm, address: e.target.value})}
                    style={inputStyle}
                    placeholder="Íjász utca 12."
                  />
                </div>

              </div>

              <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p style={{ color: '#666', fontSize: '0.85rem', margin: 0, fontStyle: 'italic' }}>
                  * Az itt megadott adatok nyilvánosak mindenki számára.
                </p>
                <button
                  onClick={handleSaveClubProfile}
                  disabled={isSavingProfile}
                  style={{
                    ...createButtonStyle,
                    padding: '12px 40px',
                    opacity: isSavingProfile ? 0.7 : 1,
                    marginBottom: 0 // Kínos margó eltávolítása
                  }}
                >
                  {isSavingProfile ? 'Mentés...' : 'Változtatások Mentése'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* VERSENYEK LISTÁJA FEJLÉC ÉS RÁCS */}
        {activeTab !== 'club-profile' && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
              <h2 style={{ color: '#b30000', margin: 0 }}>
                {activeTab === 'active' ? `Aktív versenyeid (${activeCompetitions.length})` : `Lezárt versenyek (${pastCompetitions.length})`}
              </h2>

              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <a
                  href="https://www.buymeacoffee.com/ArcheryNexus"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 15px',
                    backgroundColor: '#FFDD00',
                    color: '#000000',
                    textDecoration: 'none',
                    borderRadius: '10px',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                  }}
                >
                  <span style={{ fontSize: '18px' }}>☕</span>
                  <span>Hívd meg a fejlesztőt egy kávéra</span>
                </a>

                <button
                  style={createButtonStyle}
                  onClick={() => navigate('/verseny-letrehozas')}
                >
                  <FiPlus size={20} />
                  <span>Új verseny létrehozása</span>
                </button>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '25px' }}>
              {displayCompetitions.length > 0 ? (
                displayCompetitions.map((comp) => (
                  <div key={comp.id} style={compCardStyle}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <span style={statusBadgeStyle(comp.status || 'Aktív')}>{comp.status || 'Aktív'}</span>
                        {comp.status === 'Ready to Upload' && (
                          <span style={{
                            backgroundColor: '#e6fffa', color: '#2c7a7b', padding: '4px 10px',
                            borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', border: '1px solid #b2f5ea'
                          }}>
                            FELTÖLTÉSRE KÉSZ
                          </span>
                        )}
                        {comp.creationType === 'announcement' && comp.status !== 'Ready to Upload' && (
                          <span style={{
                            backgroundColor: '#fff5f5', color: '#c53030', padding: '4px 10px',
                            borderRadius: '20px', fontSize: '12px', fontWeight: '900', border: '1px solid #feb2b2'
                          }}>
                            NEVEZÉS ZÁRVA
                          </span>
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <FiCopy
                          style={{ cursor: 'pointer', color: '#1877F2' }}
                          title="Másolás új versenynek"
                          onClick={() => handleCopyCompetition(comp)}
                        />
                        {activeTab === 'active' && (
                          <FiEdit2
                            style={{ cursor: 'pointer', color: '#666' }}
                            title="Szerkesztés"
                            onClick={() => navigate(`/verseny-szerkesztes/${comp.id}`)}
                          />
                        )}
                        {activeTab === 'active' && (
                          <FiTrash2
                            style={{ cursor: 'pointer', color: '#b30000' }}
                            title="Törlés"
                            onClick={() => openDeleteModal(comp)}
                          />
                        )}
                      </div>
                    </div>

                    <h4 style={{ margin: '0 0 15px 0', fontSize: '18px' }}>{comp.competitionName || comp.title}</h4>

                    <div style={infoRowStyle}>
                      <FiCalendar /> {comp.competitionDate || 'Nincs megadva dátum'}
                    </div>
                    <div style={infoRowStyle}><FiMapPin /> {comp.location || 'Nincs megadva helyszín'}</div>
                    <div style={infoRowStyle}><FiUsers /> {comp.participantsCount || 0} nevező regisztrált</div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '15px' }}>
                      {activeTab === 'active' && comp.creationType !== 'announcement' && (
                        (() => {
                          const localCount = offlineStats[comp.id];
                          const remoteCount = comp.participantsCount || 0;
                          const isDownloaded = localCount !== undefined;
                          const needsUpdate = isDownloaded && localCount < remoteCount;

                          let btnColor = '#ff9800'; // Narancs
                          let btnText = 'Adatok letöltése offline módhoz';
                          let borderColor = '#fb8c00';

                          if (isDownloaded) {
                            if (needsUpdate) {
                              btnColor = '#e53e3e'; // Pirosabb narancs/vörös
                              btnText = `Frissítés szükséges (${remoteCount - localCount} új!)`;
                              borderColor = '#c53030';
                            } else {
                              btnColor = '#28a745'; // Zöld
                              btnText = 'Offline mód előkészítve';
                              borderColor = '#218838';
                            }
                          }

                          return (
                            <button
                              style={{
                                ...manageButtonStyle,
                                backgroundColor: btnColor,
                                color: '#fff',
                                borderColor: borderColor,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                              }}
                              onClick={() => downloadCompetitionOffline(comp)}
                            >
                              <FiDownload size={16} />
                              {btnText}
                            </button>
                          );
                        })()
                      )}

                      <div style={{ display: 'flex', gap: '10px' }}>
                        <button
                          style={manageButtonStyle}
                          onClick={() => navigate(`/versenyiroda/${comp.id}`)}
                        >
                          Versenyiroda
                        </button>

                        {comp.status === 'Ready to Upload' && (
                          <button
                            style={{
                              ...manageButtonStyle,
                              backgroundColor: '#28a745', // ZÖLD GOMB
                              color: '#fff',
                              borderColor: '#218838'
                            }}
                            onClick={() => {
                              setCompToPublish(comp);
                              setShowPublishConfirmModal(true);
                            }}
                          >
                            Eredmények feltöltése
                          </button>
                        )}

                        {activeTab === 'past' && comp.status === 'Lezárt' && (
                          <button
                            style={{
                              ...manageButtonStyle,
                              backgroundColor: '#eee',
                              color: '#888',
                              borderColor: '#ddd',
                              cursor: 'default'
                            }}
                            disabled
                          >
                            Eredmények feltöltve
                          </button>
                        )}

                        {comp.creationType === 'announcement' && comp.status === 'Aktív' && (
                          <button
                            style={{
                              ...manageButtonStyle,
                              backgroundColor: '#b30000',
                              color: '#fff',
                              borderColor: '#b30000'
                            }}
                            onClick={() => {
                              setCompToOpen(comp);
                              setShowOpenRegistrationModal(true);
                            }}
                          >
                            Nevezés megnyitása
                          </button>
                        )}
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        setCompToShare(comp);
                        setShowShareModal(true);
                        setCopySuccess(false);
                      }}
                      style={{
                        position: 'absolute',
                        bottom: '-12px',
                        right: '15px',
                        backgroundColor: '#1877F2',
                        color: '#fff',
                        padding: '5px 12px',
                        borderRadius: '0 0 10px 10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        zIndex: 5,
                        transition: 'all 0.2s ease'
                      }}
                      onMouseOver={(e) => { e.currentTarget.style.bottom = '-15px'; e.currentTarget.style.paddingBottom = '8px'; }}
                      onMouseOut={(e) => { e.currentTarget.style.bottom = '-12px'; e.currentTarget.style.paddingBottom = '5px'; }}
                    >
                      <FiShare2 size={14} />
                      <span>MEGOSZTÁS</span>
                    </div>

                    {comp.creationType === 'announcement' && (
                      <div style={{
                        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(-15deg)',
                        fontSize: '2rem', fontWeight: '900', color: 'rgba(197, 48, 48, 0.1)', pointerEvents: 'none',
                        whiteSpace: 'nowrap', textTransform: 'uppercase', zIndex: 0
                      }}>
                        Nevezés zárva
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div style={emptyStateStyle}>
                  <FiInbox size={50} style={{ marginBottom: '15px', color: '#ccc' }} />
                  <p style={{ margin: 0, fontWeight: 'bold', color: '#888' }}>
                    {activeTab === 'active' ? "Még nincsenek aktív versenyeid." : "Még nincsenek lezárt versenyeid."}
                  </p>
                  {activeTab === 'active' && (
                    <p style={{ fontSize: '14px', color: '#aaa' }}>Kattints az "Új verseny létrehozása" gombra!</p>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {/* --- MODALOK --- */}
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Biztosan törölni szeretnéd?</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Valóban törölni szeretnéd a(z) <br/>
              <strong>{compToDelete?.competitionName || compToDelete?.title}</strong> <br/>
              versenyt? Ez a művelet végleges.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowModal(false)}>Mégse</button>
              <button style={modalDeleteButtonStyle} onClick={handleFinalDelete}>Igen, törlöm</button>
            </div>
          </div>
        </div>
      )}



      {showOpenRegistrationModal && (
        <div style={modalOverlayStyle} onClick={() => setShowOpenRegistrationModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiInfo size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Nevezés megnyitása</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Biztosan meg akarod nyitni a nevezést?
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowOpenRegistrationModal(false)}>Mégse</button>
              <button style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }} onClick={handleOpenRegistration}>Igen, megnyitom</button>
            </div>
          </div>
        </div>
      )}

      {/* --- EREDMÉNYEK PUBLIKÁLÁSA CONFIRM MODAL --- */}
      {showPublishConfirmModal && (
        <div style={modalOverlayStyle} onClick={() => setShowPublishConfirmModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiInfo size={50} color="#28a745" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Eredmények feltöltése</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Biztosan feltöltöd és publikálod a(z) <br/>
              <strong>{compToPublish?.competitionName}</strong> eredményeit? <br/><br/>
              Ezután a versenyzők azonnal látni fogják a rangsort az appban és a weben is.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setShowPublishConfirmModal(false)}
                disabled={isPublishing}
              >
                Mégse
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }}
                onClick={handleFinalPublish}
                disabled={isPublishing}
              >
                {isPublishing ? 'Feltöltés...' : 'Igen, publikálom'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- TELEPÍTÉS INFÓ MODAL --- */}
      {showInstallInfoModal && (
        <div style={modalOverlayStyle} onClick={() => setShowInstallInfoModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '550px' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ backgroundColor: '#b30000', color: '#fff', padding: '20px', margin: '-30px -30px 20px -30px' }}>
               <h3 style={{ margin: 0 }}>Töltsd le az ArcheryNexus-t az offline élményért! 🏹</h3>
            </div>

            <p style={{ color: '#333', textAlign: 'left', lineHeight: '1.6', fontSize: '0.95rem', marginBottom: '20px' }}>
              Az ArcheryNexus letöltésével az alkalmazás közvetlenül a számítógépedre kerül.
              Így <strong>bárhol rendezz versenyt</strong>, a versenyiroda funkciók mindig működni fognak, akár internet nélkül is!
            </p>

            <p style={{ color: '#b30000', fontWeight: 'bold', textAlign: 'center', marginBottom: '15px' }}>
              A telepítéshez kattints a böngésződ címsorában (a webcím mellett) található telepítés ikonra:
            </p>

            {/* VIZUÁLIS ÚTMUTATÓ KÉPPEL ÉS NYÍLLAL */}
            <div style={{ position: 'relative', textAlign: 'center', marginBottom: '25px', backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '12px', border: '1px solid #eee' }}>
              <div style={{
                position: 'absolute',
                top: '-10px',
                right: '150px',
                color: '#b30000',
                animation: 'bounceArrow 1s infinite'
              }}>
                <FiArrowDown size={40} strokeWidth={3} />
              </div>
              <img
                src={downloadHelpImg}
                alt="Telepítés segédlet"
                style={{ width: '100%', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
              />
            </div>

            <div style={{
              backgroundColor: '#fff5f5', border: '1px solid #feb2b2', padding: '15px',
              borderRadius: '8px', margin: '10px 0', textAlign: 'left'
            }}>
              <p style={{ color: '#c53030', margin: 0, fontWeight: 'bold' }}>
                💡 Ne felejtsd el!
              </p>
              <p style={{ color: '#666', fontSize: '0.85rem', marginTop: '5px' }}>
                A zavartalan offline munkához használd az aktuális verseny kártyáján található
                <strong> "Adatok letöltése offline módhoz"</strong> gombot!
              </p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#b30000', width: '150px' }}
                onClick={() => setShowInstallInfoModal(false)}
              >
                Értem!
              </button>
            </div>

            <style>{`
              @keyframes bounceArrow {
                0%, 100% { transform: translateY(0); }
                50% { transform: translateY(-10px); }
              }
            `}</style>
          </div>
        </div>
      )}

      {/* --- MEGOSZTÁS MODAL --- */}
      {showShareModal && (
        <div style={modalOverlayStyle} onClick={() => setShowShareModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiShare2 size={50} color="#28a745" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Verseny megosztása</h3>
            <p style={{ color: '#666', marginBottom: '20px', fontSize: '0.9rem' }}>
              Másold ki az alábbi linket a verseny népszerűsítéséhez:
            </p>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f8f9fa',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              marginBottom: '25px',
              gap: '10px'
            }}>
              <input
                type="text"
                readOnly
                value={`https://archerynexus.com/verseny/${compToShare?.id}`}
                style={{
                  flex: 1,
                  border: 'none',
                  background: 'transparent',
                  fontSize: '0.85rem',
                  color: '#555',
                  outline: 'none'
                }}
              />
              <button
                onClick={handleCopyLink}
                style={{
                  backgroundColor: copySuccess ? '#28a745' : '#b30000',
                  color: 'white',
                  border: 'none',
                  padding: '8px 15px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: '0.3s'
                }}
              >
                {copySuccess ? 'Másolva!' : 'Másolás'}
              </button>
            </div>

            <button
              style={{ ...modalCancelButtonStyle, width: '100%' }}
              onClick={() => setShowShareModal(false)}
            >
              Bezárás
            </button>
          </div>
        </div>
      )}

      <style>{`
        .upload-spinner {
          width: 24px; height: 24px;
          border: 3px solid #f3f3f3; border-top: 3px solid #b30000;
          border-radius: 50%; animation: spin 1s linear infinite;
        }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

// --- STÍLUSOK (Visszaállítva multiline formátumba) ---

const tabContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  marginBottom: '25px',
  borderBottom: '1px solid #eee'
};

const tabsWrapperStyle = {
  display: 'flex',
  gap: '30px'
};

const tabStyle = (isActive) => ({
  padding: '10px 5px',
  fontSize: '18px',
  fontWeight: 'bold',
  cursor: 'pointer',
  color: isActive ? '#b30000' : '#888',
  borderBottom: isActive ? '3px solid #b30000' : '3px solid transparent',
  transition: '0.3s ease'
});

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  backdropFilter: 'blur(3px)'
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '15px',
  textAlign: 'center',
  maxWidth: '400px',
  width: '90%',
  boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
};

const modalDeleteButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const modalCancelButtonStyle = {
  backgroundColor: '#eee',
  color: '#333',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const createButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '8px 15px',
  borderRadius: '10px',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '15px',
  transition: '0.2s',
  marginBottom: '5px'
};

const statCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  borderLeft: '4px solid #b30000'
};

const compCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
  position: 'relative',
  marginBottom: '25px'
};

const emptyStateStyle = {
  gridColumn: '1 / -1',
  textAlign: 'center',
  padding: '60px 20px',
  backgroundColor: '#fdfdfd',
  borderRadius: '12px',
  border: '2px dashed #eee',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

const statusBadgeStyle = (status) => ({
  backgroundColor: status === 'Aktív' ? '#e6fffa' : '#fffaf0',
  color: status === 'Aktív' ? '#2c7a7b' : '#b7791f',
  padding: '4px 10px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 'bold'
});

const infoRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '14px',
  color: '#555',
  marginBottom: '8px'
};

const manageButtonStyle = {
  width: '100%',
  marginTop: '15px',
  padding: '10px',
  backgroundColor: 'transparent',
  border: '1.5px solid #b30000',
  color: '#b30000',
  borderRadius: '6px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const featureItemStyle = {
  fontSize: '0.85rem',
  color: '#444',
  lineHeight: '1.4',
  marginTop: '5px'
};

const sidebarItemStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 15px',
  borderRadius: '10px',
  cursor: 'pointer',
  transition: '0.2s',
  userSelect: 'none'
};

const sidebarSubItemStyle = {
  padding: '8px 0',
  fontSize: '0.9rem',
  color: '#666',
  cursor: 'pointer',
  transition: '0.2s'
};

const labelStyle = {
  display: 'block',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  color: '#b30000',
  marginBottom: '8px',
  textTransform: 'uppercase'
};

const inputStyle = {
  width: '100%',
  padding: '12px 15px',
  borderRadius: '10px',
  border: '1px solid #ddd',
  fontSize: '1rem',
  boxSizing: 'border-box',
  outline: 'none',
  transition: 'border-color 0.2s'
};

export default ClubDashboard;


